
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Entity } from '../../../../entities/entity';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';


@MergeSchema({
    entity: ActivityEntityName.Quote,
    name: 'QuoteProItemMergeSchema'
})
export class QuoteProItemMergeData {

    @MergeField()
    name: string;

    @MergeField()
    description: string;

    @MergeField()
    longDescription?: string;

    @MergeField()
    location?: string;

    @MergeField()
    note?: string;

    @MergeField()
    codeUoM: string;

    @MergeField()
    quantity: string;

    @MergeField()
    buyPrice: string;

    @MergeField()
    sellPrice: string;

    @MergeField()
    adjustment: string;

    @MergeField()
    adjustmentType: string;

    @MergeField()
    totalBuy: string;

    @MergeField()
    totalSellEx: string;

    @MergeField()
    totalSellInc: string;

    @MergeField()
    totalAdjustment: string;

    @MergeField()
    totalTax: string;

}

export const QuoteProItemMergeSchema = getSchema(QuoteProItemMergeData);

@MergeSchema({
    entity: ActivityEntityName.Quote,
    name: 'QuoteProSectionMergeSchema'
})
export class QuoteProSectionMergeData {

    @MergeField()
    name: string;

    @MergeField()
    totalBuy: string;

    @MergeField()
    totalSellEx: string;

    @MergeField()
    totalSellInc: string;

    @MergeField()
    totalAdjustment: string;

    @MergeField()
    totalTax: string;

    @MergeField({ arraySchemaName: 'QuoteProItemMergeSchema' })
    items: QuoteProItemMergeData[];

    @MergeField()
    description: string;

    costOnly?: boolean;
}

export const QuoteProSectionMergeSchema = getSchema(QuoteProSectionMergeData);

@MergeSchema({
    entity: ActivityEntityName.Quote
})
export class QuoteProMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    quoteNumber: string;

    @MergeField()
    status: string;

    @MergeField()
    date: string;

    @MergeField()
    expiryDate: string;

    @MergeField()
    createdBy: string;

    @MergeField()
    createdDate: string;

    @MergeField()
    name: string;

    @MergeField()
    description: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    totalBuy: string;

    @MergeField()
    totalSellEx: string;

    @MergeField()
    totalSellInc: string;

    @MergeField()
    totalAdjustment: string;

    @MergeField()
    totalTax: string;

    @MergeField()
    prepaymentEx: string;

    @MergeField()
    prepaymentInc: string;

    @MergeField()
    prepaymentTax: string;

    @MergeField()
    terms: string;

    theme: Entity;

    @MergeField({ arraySchemaName: 'QuoteProSectionMergeSchema' })
    sections: QuoteProSectionMergeData[];

    // Pre-joined text summary of `sections` for inline-email / Word scalar use.
    // Hydrated at the data repository (mirrors the `tags` pattern)..
    @MergeField({ displayName: 'Sections Summary (Name - Total Sell Ex)' })
    sectionsAsText: string;

    @MergeField({
        displayName: "Customer Reference"
    })
    customerRef: string;

    @MergeField({
        displayName: "PO Number"
    })
    poNumber: string;

    @MergeField({
        displayName: "Accepted By"
    })
    acceptor: string;

    @MergeField()
    signature: string;

    @MergeField()
    /** description */
    topSection: string;

    /** term */
    bottomSection: string;

    @MergeField({
        displayName: "Accepted Date"
    })
    acceptedDate: string
}

export const QuoteProMergeSchema = getSchema(QuoteProMergeData);